import { __spreadArray } from 'tslib';
import { useEffect } from 'react';
import { searchFoldersSelector } from '@keepeek/commons';
import uniq from 'lodash/uniq';
import { useRecoilStateLoadable, useSetRecoilState } from 'recoil';
import { mosaicPreloadingFolderIds } from '../atoms.js';

// Used to preload every mosaics
var useMosaicWidgets = function (_a) {
    var folderIds = _a.folderIds, _b = _a.withChildrenList, withChildrenList = _b === void 0 ? false : _b, _c = _a.countMedias, countMedias = _c === void 0 ? false : _c;
    // use search folder selector at this stage in order to preload every folderTree in one call
    var _d = useRecoilStateLoadable(searchFoldersSelector({ folderIds: folderIds, withChildrenList: withChildrenList, countMedias: countMedias })), foldersQuery = _d[0], setFolderTrees = _d[1];
    var loading = foldersQuery.state === "loading";
    var folderTrees = foldersQuery.state === "hasValue" ? foldersQuery.contents : undefined;
    useEffect(function () {
        // Keep folderTree state in sync
        setFolderTrees(folderTrees);
    }, [folderTrees, setFolderTrees]);
    // keep a preloading state so we can fallback on it
    var setPreloadFolderIds = useSetRecoilState(mosaicPreloadingFolderIds);
    useEffect(function () {
        if (folderIds) {
            if (loading) {
                setPreloadFolderIds(function (oldState) { return uniq(__spreadArray(__spreadArray([], oldState, true), folderIds, true)); });
            }
            else {
                setPreloadFolderIds(function (oldState) { return oldState.filter(function (id) { return !folderIds.includes(id); }); });
            }
        }
    }, [folderIds, loading, setPreloadFolderIds]);
    return {
        loading: loading,
        folderTrees: folderTrees
    };
};

export { useMosaicWidgets };
//# sourceMappingURL=useMosaicWidgets.js.map
